import { Icon, Spinner, SpinnerSize } from "@blueprintjs/core";
import React, { useEffect, useMemo } from "react";

import "react-filter-box/lib/react-filter-box.css"
import "./SearchBox.scss"

import useStateWithUrlParam from "../../../hooks/useStateWithUrlParam";
import { useMephistoReview } from "../../../shims/mephisto-review-hook";
import useAtomWithUrlParam from "../../../hooks/useAtomWithUrlParam";
import { versionAtom, versionAtomDefault } from "../../../atoms";
import { preprocessCorpus, findCorpusStringsInQuery } from "../../../utility/Trie";

const extractVideoUIDs = (query) => {
    return [...query.matchAll(/\w{8}-\w{4}-\w{4}-\w{4}-\w{12}/g)].map(x => x[0]);
}

export function SearchBox({ setSearchFilter, data }) {
    const [version] = useAtomWithUrlParam(versionAtom, versionAtomDefault);
    const { useSearch } = useMephistoReview();
    const [query, , setQuery, setQueryUrl] = useStateWithUrlParam('s', '');
    const { isLoading, data: searchData, refetch } = useSearch(query);

    const id_trie = useMemo(() => {
        const ids = data ? data.map((x) => x.video_uid) : [];
        return preprocessCorpus(ids)
    }, [data])

    const onChange = (e) => {
        setQuery(e.target.value);
        if (e.target.value.length === 0) {
            setSearchFilter(null);
            setQueryUrl('');
        }
        const ids_in_query = findCorpusStringsInQuery(id_trie, e.target.value);
        if (ids_in_query.length > 0) {
            setSearchFilter({ order: ids_in_query, metadata: {} });
            setQueryUrl(e.target.value);
        }
    }

    const onSubmit = () => {
        if(!data){
            return;
        }
        setQueryUrl(query);
        const ids_in_query = findCorpusStringsInQuery(id_trie, query);
        if (ids_in_query.length > 0) {
            setSearchFilter({ order: ids_in_query, metadata: {} });
            return;
        }
        query.length === 0
            ? setSearchFilter(null)
            : refetch();
    }

    useEffect(() => {
        setSearchFilter(searchData);
    }, [searchData]);

    useEffect(() => onSubmit(query), [data]);

    const searchIcon = isLoading
        ? <Spinner size={SpinnerSize.SMALL} className='searchbox-icon disabled' />
        : <Icon icon={'search'} className='searchbox-icon clickable' onClick={onSubmit} />;

    return <div className="searchbox">
        {searchIcon}
        <input type="text" disabled={isLoading} value={query} placeholder='Paste video uids or semantic search for anything' className='searchbox-input' onChange={onChange} onKeyDown={(e) => e.key === 'Enter' && onSubmit(e)} />
    </ div>
};
